import React, { useState } from "react";
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  HeroHeading,
  Span,
  HeroP,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight,
} from "./Herostyles";
import video from "../../Video/video.mp4";
import { Button } from "../Globalstyles/Button";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";

function Hero() {
  const [hover, setHover] = useState(false);
  const onHover = () => {
    setHover(!hover);
  };

  return (
    <HeroContainer>
      <HeroBg>
        <VideoBg autoPlay="true" loop muted src={video} type="video/mp4" />
      </HeroBg>
      <HeroContent>
        <Slide bottom>
          <HeroHeading>
            Stay Fit<Span>.</Span>{" "}
          </HeroHeading>
        </Slide>
        <Fade bottom>
          <HeroP>
            Welcome to our gym and get unlimited gym access low monthly
            subscription fee. <br />
            Location: Bomet Town, opposite Co-operative bank
          </HeroP>
          <HeroBtnWrapper>
            <Button
              primary="true"
              dark="true"
              to="/signin"
              onMouseEnter={onHover}
              onMouseLeave={onHover}
            >
              Get started
              {hover ? <ArrowForward /> : <ArrowRight />}
            </Button>
          </HeroBtnWrapper>
        </Fade>
      </HeroContent>
    </HeroContainer>
  );
}

export default Hero;
